'use strict';

import React from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import _ from 'lodash'

import Layout from '@Layout/BackOffice'

import UpdateForm from '@/Form/UpdateForm'

import _config from '@Config/Configuration/place'

import Geocoder from '@/Maps/Geocoder'

let config = _.cloneDeep(_config);

export default class PlacePage extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state = { };

		this.init.bind(this)();

		this.handleAddressChange = this.handleAddressChange.bind(this);
	}

	init ()
	{
		const component = this, state = this.state;

		config.hookOnUpdate = function (e, data)
		{
			const _component = this, _props = this.props, _state = this.state;

			component.setState(
			{
				name: _state.form_data['place[name]'],
				line_1: _state.form_data['place[address][line_1]'],
				line_2: _state.form_data['place[address][line_2]'],
				zip_code: _state.form_data['place[address][zip_code]'],
				city: _state.form_data['place[address][city]']
			});
		}

		config.hookGetDataAjax = function (form_data, response)
		{
			let place = response.data || { };

			component.setState(
			{
				ready: true,
				geocoding: place.geocoding
			});
		};

		config.form_title = 'Modification d\'un lieu';
	}

	componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();
	}

	shouldComponentUpdate (next_props, next_state)
	{
		const component = this, props = this.props, state = this.state;

		let fields = ['name', 'city', 'line_1', 'line_2', 'zip_code'];

		return Boolean(fields.find(field => state[field] !== next_state[field]));
	}

	handleAddressChange (geocoding)
	{
		let form_data = new FormData();

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		qwest.post('/place/update-geocoding',
		{
			id: id,
			geocoding: geocoding
		})
		.then(function (xhr, response)
		{
			console.info(response);
		})
		.catch(function (error, xhr, response)
		{
			console.error(error);
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const address =
		{
			name: state.name,
			line_1: state.line_1,
			line_2: state.line_2,
			zip_code: state.zip_code,
			city: state.city
		};

		let geocoder;

		if (state.ready === true)
		{
			if (state.name || state.line_1)
			{
				geocoder =
				(
					<Geocoder address={ address } geocoding={ state.geocoding }
						onChange={ component.handleAddressChange } />
				);
			}
			else
			{
				geocoder =
				(
					<div className="c-message c-message--green">
						<div className="c-message__content">
							Le Google Maps a besoin d'une adresse renseignée.
						</div>
					</div>
				);
			}
		}

		var output =
		(
			<Layout history={ props.history }
				page_title_pathname="/configuration/lieux/modifier">

				<div className="page-content">

					<div className="o-content">

						<TransitionGroup className="page-form-container">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={{ enter: 240, exit: 320, appear: 500 }}>

								<UpdateForm className="u-no-margin-top"
									config={ config }>

									<div className="o-content">
										{ geocoder }
									</div>

								</UpdateForm>

							</CSSTransition>

						</TransitionGroup>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}